<template>
  <div class="mt-6 space-y-6">
    <div v-if="isLoading" class="py-12 text-center">
      <div
        class="animate-spin rounded-full h-8 w-8 border-2 border-gray-300 border-t-purple-600 mx-auto"
      ></div>
      <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">Pipeline per afdeling laden...</p>
    </div>

    <div v-else-if="error" class="py-12 text-center text-sm text-gray-500 dark:text-gray-400">
      {{ error }}
    </div>

    <template v-else-if="data">
      <TeamPipelineChart :data="data" />
      <TeamComparisonChart :data="data" />
      <EmployeeFunnelTable :data="data" />
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { predictionService } from '@/services/predictionService.js'
import TeamPipelineChart from './TeamPipelineChart.vue'
import TeamComparisonChart from './TeamComparisonChart.vue'
import EmployeeFunnelTable from './EmployeeFunnelTable.vue'

const props = defineProps({
  reloadTrigger: { type: Number, default: 0 }
})

const data = ref(null)
const isLoading = ref(false)
const error = ref('')

async function loadData() {
  isLoading.value = true
  error.value = ''
  try {
    data.value = await predictionService.getEmployeePipeline()
  } catch {
    error.value = 'Kon pipeline data niet laden'
  } finally {
    isLoading.value = false
  }
}

watch(
  () => props.reloadTrigger,
  () => {
    loadData()
  }
)

onMounted(loadData)
</script>
